import { all, put, select, takeLatest } from "redux-saga/effects";

import {
  selectAuthToken,
  selectOrganisationId,
} from "../selectors/login.selector";
import * as API from "../utils/api";
import axios from "axios";
import {
  getListOfAllAudits,
  getAuditById,
  setAuditData,
  setListOfAllAudits,
  updateAuditData,
  setAuditIssueCAPData,
  uploadAuditReport,
  setUploadAuditReportFiles,
  processAuditReport,
  setProcessAuditReportFiles,
  regenerateCap,
  setRegenerateCapResult,
  deleteCapDetailsById,
  getListOfAuditsInCapManagement,
  bulkUpdateCapStatus,
  setListOfAuditsInCapManagement,
  updateIssueData,
  uploadCapProof,
  updateIssueCapData,
  updateIssueProofData,
  setAdditionalContextForProof,
  bulkUpdateCapProofWithAdditionalContext,
  setResources,
  getResources,
} from "../reducers/audit.reducer";
import { logout } from "../reducers/login.reducer";
import { selectSaveStatus } from "../selectors/misc.selector";
import {
  setFilesUploadedIds,
  setFileUploadStatus,
  setSaveStatus,
} from "../reducers/misc.reducer";
import { toast } from "react-toastify";

function* getListOfAuditsWorker(action) {
  const authToken = yield select(selectAuthToken);
  const organisationId = yield select(selectOrganisationId);
  const { limit, offset, supplierId } = action.payload;

  const requestURL = API.AUDITS.LIST.replace(
    "<ORGANISATION_ID>",
    organisationId
  ).replace("<SUPPLIER_ID>", supplierId);

  const headers = {
    "Content-Type": "application/json",
    Authorization: authToken,
  };

  const params = { limit, offset };

  try {
    const response = yield axios.get(requestURL, { headers, params });

    if (response && response.status === 200 && response.data) {
      if (response.data.success) {
        yield put(
          setListOfAllAudits({
            audits: response.data.results.audits,
            auditCount: response.data.results.auditCount,
            nonActiveAuditCount: response.data.results.nonActiveAuditsByFactory,
          })
        );
      }
    }
  } catch (error) {
    console.error("Failed to fetch suppliers:", error);
    if (error && error.response && error.response.status === 401) {
      yield put(logout());
    }
    // Handle errors here, possibly dispatching a failure action
  }
}

function* getAuditByIdWorker(action) {
  const authToken = yield select(selectAuthToken);
  const organisationId = yield select(selectOrganisationId);

  const requestURL = API.AUDITS.GET_BY_ID.replace(
    "<ORGANISATION_ID>",
    organisationId
  )
    .replace("<SUPPLIER_ID>", action.payload.supplierId)
    .replace("<FACTORY_ID>", action.payload.factoryId)
    .replace("<AUDIT_ID>", action.payload.auditId);

  const headers = {
    "Content-Type": "application/json",
    Authorization: authToken,
  };

  try {
    const response = yield axios.get(requestURL, { headers });

    if (response && response.status === 200 && response.data) {
      if (response.data.success) {
        yield put(setAuditData(response.data.results.auditData));
        yield put(setAuditIssueCAPData(response.data.results.capDetails));
      }
    }
  } catch (error) {
    console.error("Failed to fetch suppliers:", error);
    if (error && error.response && error.response.status === 401) {
      yield put(logout());
    }
    // Handle errors here, possibly dispatching a failure action
  }
}

function* updateAuditDataWorker(action) {
  const authToken = yield select(selectAuthToken);
  const organisationId = yield select(selectOrganisationId);

  const requestURL = API.AUDITS.UPDATE_BY_ID.replace(
    "<ORGANISATION_ID>",
    organisationId
  )
    .replace("<SUPPLIER_ID>", action.payload.supplierId)
    .replace("<FACTORY_ID>", action.payload.factoryId)
    .replace("<AUDIT_ID>", action.payload.auditId);

  const headers = {
    "Content-Type": "application/json",
    Authorization: authToken,
  };

  const body = {
    ...action.payload.changes,
  };
  const params = {
    issueId: action.payload?.issueId || "",
  };
  try {
    const response = yield axios.put(requestURL, body, { headers, params });

    if (response && response.status === 200 && response.data) {
      if (response.data.success) {
        yield put(setAuditData(response.data.results.auditData));
        yield put(setAuditIssueCAPData(response.data.results.capDetails));

        yield put(setSaveStatus("saved"));
      }
    }
  } catch (error) {
    console.error("Failed to fetch suppliers:", error);
    if (error && error.response && error.response.status === 401) {
      yield put(logout());
    }
    // Handle errors here, possibly dispatching a failure action
  }
}

function* uploadAuditReportWorker(action) {
  const authToken = yield select(selectAuthToken);
  const formData = new FormData();
  const { auditId, issueId } = action.payload;

  const requestURL = API.CAP_MANAGEMENT.UPLOAD_PROOF.replace(
    "<AUDIT_ID>",
    auditId
  ).replace("<ISSUE_ID>", issueId);

  let headers = {
    "Content-Type": "multipart/form-data",
    Authorization: authToken,
  };
  if (action.payload.type === "capClosed") {
    headers["Type"] = action.payload.type;
  }
  if (action.payload.auditId) {
    let fileUpload = {};

    for (let file of action.payload.file) {
      fileUpload[file.id] = false;

      const formData = new FormData();
      formData.append("file", file.file);
      try {
        const response = yield axios.post(requestURL, formData, {
          headers,
        });

        if (response && response.status === 200 && response.data) {
          if (response.data.success) {
            fileUpload[file.id] = true;
            yield put(
              updateIssueProofData({
                proofDocuments: response.data.results,
                issueId: action.payload.issueId,
                status: response.data.status,
              })
            );
            // yield put(setUploadAuditReportFiles(response.data.results));
            // yield put(setAuditData(response.data.results.auditData));
            // yield put(setAuditIssueCAPData(response.data.results.capDetails));
          }
        }
      } catch (error) {
        console.error("Failed to fetch suppliers:", error);
        if (error && error.response && error.response.status === 401) {
          yield put(logout());
        }
        // Handle errors here, possibly dispatching a failure action
      }
    }
    yield put(setFilesUploadedIds(fileUpload));
  } else {
    formData.append("file", action.payload.file);

    try {
      const response = yield axios.post(requestURL, formData, {
        headers,
      });

      if (response && response.status === 200 && response.data) {
        if (response.data.success) {
          yield put(setUploadAuditReportFiles(response.data.results));
          // yield put(setAuditData(response.data.results.auditData));
          // yield put(setAuditIssueCAPData(response.data.results.capDetails));
        }
      }
    } catch (error) {
      console.error("Failed to fetch suppliers:", error);
      if (error && error.response && error.response.status === 401) {
        yield put(logout());
      }
      // Handle errors here, possibly dispatching a failure action
    }
  }
}

function* uploadCapProofWorker(action) {
  const authToken = yield select(selectAuthToken);
  const formData = new FormData();
  const { auditId, issueId } = action.payload;

  const requestURL = API.CAP_MANAGEMENT.UPLOAD_PROOF.replace(
    "<AUDIT_ID>",
    auditId
  ).replace("<ISSUE_ID>", issueId);

  let headers = {
    "Content-Type": "multipart/form-data",
    Authorization: authToken,
  };

  if (action.payload.auditId) {
    let fileUpload = {};

    for (let file of action.payload.file) {
      fileUpload[file.id] = false;

      const formData = new FormData();
      formData.append("file", file.file);
      try {
        const response = yield axios.post(requestURL, formData, {
          headers,
        });

        if (response && response.status === 200 && response.data) {
          if (response.data.success) {
            fileUpload[file.id] = true;
            yield put(
              updateIssueProofData({
                proofDocuments: response.data.results,
                issueId: action.payload.issueId,
                status: response.data.status,
              })
            );
            // yield put(setUploadAuditReportFiles(response.data.results));
            // yield put(setAuditData(response.data.results.auditData));
            // yield put(setAuditIssueCAPData(response.data.results.capDetails));
          }
        }
      } catch (error) {
        console.error("Failed to fetch suppliers:", error);
        if (error && error.response && error.response.status === 401) {
          yield put(logout());
        }
        // Handle errors here, possibly dispatching a failure action
      }
    }
    // yield put(setFilesUploadedIds(fileUpload));
  } else {
    formData.append("file", action.payload.file);

    try {
      const response = yield axios.post(requestURL, formData, {
        headers,
      });

      if (response && response.status === 200 && response.data) {
        if (response.data.success) {
          yield put(setUploadAuditReportFiles(response.data.results));
          // yield put(setAuditData(response.data.results.auditData));
          // yield put(setAuditIssueCAPData(response.data.results.capDetails));
        }
      }
    } catch (error) {
      console.error("Failed to fetch suppliers:", error);
      if (error && error.response && error.response.status === 401) {
        yield put(logout());
      }
      // Handle errors here, possibly dispatching a failure action
    }
  }
}

function* processAuditReportWorker(action) {
  const authToken = yield select(selectAuthToken);
  const organisationId = yield select(selectOrganisationId);
  const formData = new FormData();

  const requestURL = API.AUDITS.PROCESS_REPORT.replace(
    "<ORGANISATION_ID>",
    organisationId
  )
    .replace("<SUPPLIER_ID>", action.payload.supplierId)
    .replace("<FACTORY_ID>", action.payload.factoryId)
    .replace("<AUDIT_ID>", action.payload.auditId);

  const headers = {
    "Content-Type": "multipart/form-data",
    Authorization: authToken,
  };
  const params = {
    emails: "",
  };
  if (action.payload.emails) {
    params.emails = action.payload.emails;
  }

  if (action.payload.auditId === "none") {
    let fileUpload = {};

    for (let file of action.payload.file) {
      fileUpload[file.id] = false;

      const formData = new FormData();
      formData.append("file", file.file);
      try {

        yield put(setFileUploadStatus(1)); // this means uploading
        const response = yield axios.post(requestURL, formData, {
          headers,
          params,
        });

        if (response && response.status === 200 && response.data) {
          if (response.data.success) {

            toast.success("File uploaded successfully");
            yield put(setFileUploadStatus(2)); // means uploaded
            fileUpload[file.id] = true;
            // yield put(setProcessAuditReportFiles(response.data.results));
          }
        }
      } catch (error) {
        console.error("Failed to process audit report:", error);
        if (error && error.response && error.response.status === 401) {
          yield put(logout());
        }
        // Handle errors here, possibly dispatching a failure action
      }
    }
    yield put(setFilesUploadedIds(fileUpload));
  } else {
    formData.append("file", action.payload.file);

    try {
      const response = yield axios.post(requestURL, formData, {
        headers,
      });

      if (response && response.status === 200 && response.data) {
        if (response.data.success) {
          yield put(setProcessAuditReportFiles(response.data.results));
        }
      }
    } catch (error) {
      console.error("Failed to process audit report:", error);
      if (error && error.response && error.response.status === 401) {
        yield put(logout());
      }
      // Handle errors here, possibly dispatching a failure action
    }
  }
}

function* regenerateCapWorker(action) {
  const authToken = yield select(selectAuthToken);
  const organisationId = yield select(selectOrganisationId);

  const requestURL = API.AUDITS.REGENERATE_CAP.replace(
    "<ORGANISATION_ID>",
    organisationId
  )
    .replace("<SUPPLIER_ID>", action.payload.supplierId)
    .replace("<FACTORY_ID>", action.payload.factoryId)
    .replace("<AUDIT_ID>", action.payload.auditId);

  const headers = {
    "Content-Type": "application/json",
    Authorization: authToken,
  };

  try {
    const response = yield axios.put(requestURL, {}, { headers });

    if (response && response.status === 200 && response.data) {
      if (response.data.success) {
        yield put(setRegenerateCapResult(response.data.results));
      }
    }
  } catch (error) {
    console.error("Failed to regenerate CAP:", error);
    if (error && error.response && error.response.status === 401) {
      yield put(logout());
    }
    // Handle errors here, possibly dispatching a failure action
  }
}
function* deleteCapDetailsByIdWorker(action) {
  const authToken = yield select(selectAuthToken);
  const organisationId = yield select(selectOrganisationId);

  const requestURL = API.AUDITS.DELETE_CAP_DETAILS_BY_ID.replace(
    "<ORGANISATION_ID>",
    organisationId
  )
    .replace("<SUPPLIER_ID>", action.payload.supplierId)
    .replace("<FACTORY_ID>", action.payload.factoryId)
    .replace("<AUDIT_ID>", action.payload.auditId)
    .replace("<FINDING_ID>", action.payload.capDetailsId);

  const headers = {
    "Content-Type": "application/json",
    Authorization: authToken,
  };

  try {
    const response = yield axios.delete(requestURL, { headers });

    if (response && response.status === 200 && response.data) {
      if (response.data.success) {
        yield put(setAuditData(response.data.results.auditData));
        yield put(setAuditIssueCAPData(response.data.results.capDetails));
      }
    }
  } catch (error) {
    console.error("Failed to delete cap details:", error);
  }
}

function* getListOfAuditsInCapManagementWorker(action) {
  const authToken = yield select(selectAuthToken);
  const organisationId = yield select(selectOrganisationId);
  const { factoryId, supplierId } = action.payload;

  const requestURL = API.AUDITS.GET_LIST_OF_AUDITS_IN_CAP_MANAGEMENT.replace(
    "<SUPPLIER_ID>",
    supplierId
  );

  const headers = {
    "Content-Type": "application/json",
    Authorization: authToken,
  };
  const params = {
    factoryId: factoryId || null,
  };
  try {
    const response = yield axios.get(requestURL, { headers, params });

    if (response && response.status === 200 && response.data) {
      if (response.data.success) {
        yield put(setListOfAuditsInCapManagement(response.data.results.audits));
      }
    }
  } catch (error) {
    console.error("Failed to fetch suppliers:", error);
    if (error && error.response && error.response.status === 401) {
      yield put(logout());
    }
    // Handle errors here, possibly dispatching a failure action
  }
}
function* updateIssueDataWorker(action) {
  const authToken = yield select(selectAuthToken);
  const { auditId, issueId, changes } = action.payload;

  const requestURL = API.CAP_MANAGEMENT.UPDATE.replace("<AUDIT_ID>", auditId);

  const headers = {
    "Content-Type": "application/json",
    Authorization: authToken,
  };
  const body = {
    ...changes,
  };
  const params = {
    issueId: issueId || null,
  };
  try {
    const response = yield axios.put(requestURL, body, { headers, params });

    if (response && response.status === 200 && response.data) {
      if (response.data.success) {
        if (action.payload.changes.submitTriggered) {
          yield put(bulkUpdateCapStatus(response.data.results));
        } else if (action.payload.changes.submitTriggeredForProof) {
          yield put(bulkUpdateCapStatus(response.data.results));
        } else {
          yield put(
            updateIssueCapData({
              issueId,
              actionPlan: response.data.results.actionPlan,
              brandResponse: response.data.results.brandResponse,
              status: response.data.results.status,
              capStatus: response.data.results.capStatus,
            })
          );
        }
        // yield put(setAuditData(response.data.results.auditData));
        // yield put(setAuditIssueCAPData(response.data.results.capDetails));
      }
    }
  } catch (error) {
    console.error("Failed to fetch suppliers:", error);
    if (error && error.response && error.response.status === 401) {
      yield put(logout());
    }
    // Handle errors here, possibly dispatching a failure action
  }
}
function* setAdditionalContextForProofWorker(action) {
  const authToken = yield select(selectAuthToken);
  const { auditId, issueId, additionalContext } = action.payload;

  const requestURL =
    API.CAP_MANAGEMENT.SET_ADDITIONAL_CONTEXT_FOR_PROOF.replace(
      "<AUDIT_ID>",
      auditId
    ).replace("<ISSUE_ID>", issueId);

  const headers = {
    "Content-Type": "application/json",
    Authorization: authToken,
  };
  const body = {
    context: additionalContext,
  };
  const params = {
    issueId: issueId || null,
  };
  try {
    const response = yield axios.put(requestURL, body, { headers, params });

    if (response && response.status === 200 && response.data) {
      if (response.data.success) {
        yield put(
          bulkUpdateCapProofWithAdditionalContext(response.data.results)
        );
        // yield put(setAuditData(response.data.results.auditData));
        // yield put(setAuditIssueCAPData(response.data.results.capDetails));
      }
    }
  } catch (error) {
    console.error("Failed to fetch suppliers:", error);
    if (error && error.response && error.response.status === 401) {
      yield put(logout());
    }
    // Handle errors here, possibly dispatching a failure action
  }
}
function* getResourcesWorker(action) {
  const authToken = yield select(selectAuthToken);
  const { supplierId } = action.payload;

  const requestURL = API.AUDITS.GET_RESOURCES;

  const headers = {
    "Content-Type": "application/json",
    Authorization: authToken,
  };

  const params = {
    supplierId: supplierId || null,
  };
  try {
    const response = yield axios.get(requestURL, { headers, params });

    if (response && response.status === 200 && response.data) {
      if (response.data.success) {
        yield put(setResources(response.data.results.resources));
      }
    }
  } catch (error) {
    console.error("Failed to fetch resources:", error);
  }
}
function* watchAuditSaga() {
  yield takeLatest(getListOfAllAudits.type, getListOfAuditsWorker);
}

function* watchAuditByIdSaga() {
  yield takeLatest(getAuditById.type, getAuditByIdWorker);
}

function* watchUpdateAuditDataSaga() {
  yield takeLatest(updateAuditData.type, updateAuditDataWorker);
}

function* watchUploadAuditReportSaga() {
  yield takeLatest(uploadAuditReport.type, uploadAuditReportWorker);
}

function* watchUploadCapProofSaga() {
  yield takeLatest(uploadCapProof.type, uploadCapProofWorker);
}

function* watchProcessAuditReportSaga() {
  yield takeLatest(processAuditReport.type, processAuditReportWorker);
}

function* watchRegenerateCapSaga() {
  yield takeLatest(regenerateCap.type, regenerateCapWorker);
}
function* watchDeleteCapDetailsByIdSaga() {
  yield takeLatest(deleteCapDetailsById.type, deleteCapDetailsByIdWorker);
}
function* watchUpdateIssueDataSaga() {
  yield takeLatest(updateIssueData.type, updateIssueDataWorker);
}
function* watchGetListOfAuditsInCapManagementSaga() {
  yield takeLatest(
    getListOfAuditsInCapManagement.type,
    getListOfAuditsInCapManagementWorker
  );
}
function* watchSetAdditionalContextForProofSaga() {
  yield takeLatest(
    setAdditionalContextForProof.type,
    setAdditionalContextForProofWorker
  );
}
function* watchGetResourcesSaga() {
  yield takeLatest(getResources.type, getResourcesWorker);
}
export default function* rootSaga() {
  yield all([
    watchAuditSaga(),
    watchAuditByIdSaga(),
    watchUpdateAuditDataSaga(),
    watchUploadAuditReportSaga(),
    watchUploadCapProofSaga(),
    watchProcessAuditReportSaga(),
    watchRegenerateCapSaga(),
    watchDeleteCapDetailsByIdSaga(),
    watchGetListOfAuditsInCapManagementSaga(),
    watchUpdateIssueDataSaga(),
    watchSetAdditionalContextForProofSaga(),
    watchGetResourcesSaga(),
  ]);
}
